"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.repeatTimes = repeatTimes;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _curry = require("../../internal/curry");

var _iterable = require("../../internal/iterable");

var _marked = _regenerator["default"].mark(repeatTimes);

function repeatTimes(n, item) {
  return _regenerator["default"].wrap(function repeatTimes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!n--) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return item;

        case 3:
          _context.next = 0;
          break;

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var _default = (0, _curry.curry)((0, _iterable.wrapWithMethodIterable)(repeatTimes), repeatTimes.length);

exports["default"] = _default;